import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  loggedInUser: null,
  nextRoute: null,
  token: null,
  userIsLoggedIn: false,
};

const mutations = {
  login(store, data) {
    state.token = data.id;
    state.loggedInUser = data.user;
    Vue.cookie.set('userId', data.user.id, 1);
    Vue.cookie.set('token', data.token.token, 1);
    Vue.cookie.set('refreshToken', data.token.refreshToken, 1);
    state.userIsLoggedIn = true;
  },

  logout() {
    Vue.cookie.delete('token');
    Vue.cookie.delete('userId');
    state.loggedInUser = null;
    state.userIsLoggedIn = false;
    state.token = null;
  },
};

const getters = {
  getToken() {
    return state.token;
  },

  getUser() {
    return state.loggedInUser;
  },

  isUserLoggedIn() {
    return state.userIsLoggedIn;
  },
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions: {},
});
